import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Mulțumim, {{name}}',
    confirmation_email:
      'Vei primi curând un e-mail de confirmare cu numărul comenzii de la partenerul nostru tehnologic {{provider_email}}',
    need_help: 'Ai nevoie de ajutor?',
  },
  labels: {
    order_number: 'Nr. comandă: {{number}}',
    order_number_short: '#{{number}}',
    today: 'Astăzi',
    was_prefix: 'a fost',
    restaurant: 'Restaurant',
    order_details: 'Detalii comandă',
    your_details: 'Datele tale',
    contact: 'Contact',
    payment: 'Plată',
    payment_method: 'Metodă de plată',
    delivery: 'Livrare',
    delivery_details: 'Detalii livrare',
    pickup_details: 'Detalii ridicare',
    pickup_instruction: '📋 Spune-ne numărul comenzii {{number}} când ridici comanda.',
    billing_info: 'Informații de facturare',
    order_note: 'Notă comandă',
    order_summary: 'Sumar comandă',
    help: 'Ai nevoie de ajutor? Contactează-ne la {{phone_number}}',
  },
  status: {
    canceled: 'Comandă anulată',
    received: 'Comandă primită',
    confirmed: 'Comandă confirmată!',
  },
  eta: {
    min_label: 'MIN',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'Ridicare',
    [ORDER_METHODS.DELIVERY]: 'Livrare',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Serviciu la cameră',
      [RoomServiceLocationType.TableService]: 'Serviciu la masă',
    },
  },
  room_service_details: {
    [RoomServiceLocationType.RoomService]: '(camera #{{details}})',
    [RoomServiceLocationType.TableService]: '(masa #{{details}})',
  },
  rewards: {
    member: {
      pill_title: 'Puncte câștigate',
      from_order: 'puncte din această comandă',
      total_balance: 'Sold total',
      reward_value: 'Valoarea recompensei',
      redeem_hint: '✓ Poți valorifica până la {{points}} pts ({{amount}}) la următoarea comandă',
      points_to_redeem: 'Mai ai nevoie de {{points}} puncte pentru a valorifica recompensa',
    },
    guest: {
      pill_title: 'Recompense',
      earned_heading: 'Ai câștigat <highlight>{{points}} puncte</highlight> pentru această comandă',
      worth_on_next: 'Valoare de <strong>{{amount}}</strong> la comanda viitoare',
      ready_to_claim: 'Gata de revendicat',
      next_order_discount: 'Reducere la comanda viitoare',
      claim_cta: 'Revendică {{points}} pts — înscrie-te gratuit',
      claim_note: 'Durează 30 de secunde · punctele se creditează instant',
    },
  },
  buttons: {
    back_to_menu: 'Înapoi la meniu',
    back_to_checkout: 'Înapoi la plată',
    contact_us: 'Contactează-ne la {{phone_number}}',
    try_again: 'Încearcă din nou',
  },
  loading: {
    processing_payment: 'Te rugăm să nu părăsești pagina în timp ce procesăm plata',
  },
  success_messages: {
    order_placed: {
      title: '✅ Comandă plasată cu succes!',
      description: 'Comanda ta a fost plasată cu succes.',
    },
  },
  error_messages: {
    failed_to_load: 'Comanda nu a putut fi încărcată. Te rugăm să încerci din nou.',
    payment_failed: 'Plata a eșuat, te rugăm să încerci din nou',
  },
  load_failed: {
    title: 'Nu am putut încărca comanda ta',
    description:
      'A apărut o eroare la încărcarea detaliilor comenzii tale. Te rugăm să încerci din nou. Dacă problema persistă, contactează asistența și te vom ajuta imediat.',
  },
};
